var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { EmailTemplateGroup } from 'packages/email/entities/EmailTemplateGroup';
import { EntityBuilder } from '@decahedron/entity';
import store from '@/store/core';
import ENV from 'config/env';
var EmailTemplateGroupRepository = /** @class */ (function (_super) {
    __extends(EmailTemplateGroupRepository, _super);
    function EmailTemplateGroupRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        _this.url = 'mail/template-groups';
        _this.entity = EmailTemplateGroup;
        return _this;
    }
    EmailTemplateGroupRepository.prototype.getTemplateGroupsForCompany = function (companyId) {
        var _this = this;
        this.url = "company/" + companyId + "/template-groups";
        return this.get(this.url).then(function (results) {
            _this.url = 'mail/template-groups';
            return EntityBuilder.buildMany(EmailTemplateGroup, results.data.data);
        });
    };
    EmailTemplateGroupRepository.prototype.addNewTemplateGroup = function (name) {
        var data = new FormData();
        data.append('company_id', store.getters.currentCompanyId.toString());
        data.append('title', name);
        return this.create(data);
    };
    EmailTemplateGroupRepository.prototype.deleteTemplateGroup = function (templateGroup) {
        return this.delete(templateGroup.id);
    };
    EmailTemplateGroupRepository.prototype.updateTemplateGroup = function (templateGroup) {
        return this.update(templateGroup.id, templateGroup);
    };
    return EmailTemplateGroupRepository;
}(AbstractRepository));
export { EmailTemplateGroupRepository };
